import * as React from 'react';

type Props = {
  json: object;
};

const JsonDisplay = (props: Props) => {
  return <pre>{JSON.stringify(props.json, null, 2)}</pre>;
};

export default JsonDisplay;
